import React from 'react';
import './order-summary.scss';
import CartItemSummary from '../cart-item-summary/cart-item-summary';

/**
 * An order summary component containing cart item summaries
 * @param cashOrderCartItems The key/value pair object containing cart items
 * @param cashCartSubTotal The subtotal for the cart items
 * @param addEditAmpolCash onClick event for Add/Edit AmpolCash option
 * @returns JSX Element
 */

const OrderSummary = ({ cashOrderCartItems, cashCartSubTotal, addEditAmpolCash }) => {
  return <>
    <div className='orders'>
      <h1 className='orders__title'>Order Summary</h1>
      <div className='orders__cart-items'>
        <ul aria-label='cart items'>
          {Object.keys(cashOrderCartItems).map((uuid) =>
            <li key={uuid}>
              <CartItemSummary
                showBase={true}
                showImage={true}
                showTotal={true}
                showQuantity={true}
                showDelivery={true}
                cartItem={cashOrderCartItems[uuid]}
              />
            </li>
          )}
        </ul>
      </div>
      <div className='orders__footer'>
        <button onClick={addEditAmpolCash} className='orders__add' >Add/Edit AmpolCash</button>
        <hr />
        <ul className='orders__total'>
          <li>Sub Total</li>
          <li>${cashCartSubTotal}</li>
        </ul>
      </div>
    </div>
  </>;

};

export default OrderSummary;
